import { useQuery } from '@tanstack/react-query';

import { getChartData } from '@/components/Chart/api/getChartData';
import { ChartQueryKeys } from '@/components/Chart/queries/queryKeys';
import type { ChartType } from '@/components/Chart/types/highcharts';
import type { TemplateChartSeries } from '@/pages/Markets/MarketsComponents/types';

export const useChartData = (
  templateChartSeries: TemplateChartSeries[] | undefined,
  chartType: ChartType
) => {
  return useQuery({
    queryKey: ChartQueryKeys.chart(templateChartSeries, chartType),
    queryFn: () => {
      if (!templateChartSeries) return Promise.resolve(null);
      return getChartData(templateChartSeries, chartType);
    },
    enabled: !!templateChartSeries,
    refetchOnWindowFocus: false,
    gcTime: Infinity,
    staleTime: Infinity
  });
};
